var React = require('react');

function Insurance (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.9996 0L4.36328 8.72727V21.8182C4.36328 33.9273 12.7415 45.2509 23.9996 48C35.2578 45.2509 43.636 33.9273 43.636 21.8182V8.72727L23.9996 0ZM39.2724 21.8182C39.2724 31.68 32.7706 40.7782 23.9996 43.4836C15.2287 40.7782 8.72692 31.68 8.72692 21.8182V11.5636L23.9996 4.77818L39.2724 11.5636V21.8182ZM13.9851 23.1055L10.9087 26.1818L19.636 34.9091L37.0906 17.4545L34.0142 14.3564L19.636 28.7345L13.9851 23.1055Z","fill":"black"}));
}

Insurance.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Insurance;

Insurance.default = Insurance;
